export default __webpack_public_path__ + "static/media/eu_platesc_banner.397b6f54.png";